import { REACT_APP_BASE_URL } from '../consts'
import request from './request'

export default async (data) => {
  const ans = await request({
    url: `${REACT_APP_BASE_URL}/send-otp`,
    method: 'post',
    data
  })
  return ans
}
